import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationResult, PhoneAuthProvider, RecaptchaVerifier, getAuth, signInWithPhoneNumber } from '@angular/fire/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as firebase from 'firebase/compat';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { WindowService } from 'src/@order/services/windows.service';

@Component({
  selector: 'app-otp-verification-dialog',
  templateUrl: './otp-verification-dialog.component.html',
  styleUrls: ['./otp-verification-dialog.component.scss']
})
export class OtpVerificationDialogComponent implements OnInit, OnDestroy {
  windowRef
  phone
  otp: string;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {}
  };
  appVerifier
  user
  verificationId
  constructor(
    private _progressBar: ProgressBarService,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public afAuth: AngularFireAuth,
    private _snackBar: MatSnackBar,
    public _matDialogRef: MatDialogRef<OtpVerificationDialogComponent>,
    private win: WindowService,
  ) {

  }

  ngOnInit(): void {
    this.windowRef = this.win.windowRef;
    this.phone = this._data.phoneNumber;
    // const auth = getAuth();
    this.windowRef.recaptchaVerifier = undefined;
    const auth = getAuth();
    if (!this.windowRef.recaptchaVerifier) {
      this.windowRef.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          // console.log("call back response in registration", response)
        },
        'expired-callback': (res) => {
          // console.log("response expired-callback in registration", res)
        }
      }, auth);
    }

    this.appVerifier = this.windowRef.recaptchaVerifier;
    this.afAuth.signInWithPhoneNumber(this.phone, this.appVerifier).then((confirmationResult: any) => {
      console.log("verifictionId", confirmationResult);
      this.verificationId = confirmationResult?.verificationId;
      // Handle further actions like storing confirmationResult to verify OTP
      this._snackBar.open(`We've sent a one-time password (OTP) to your device. Kindly check and enter it to proceed.`, 'OKAY', { duration: 3000 })

    }).catch((error) => {
      // Error sending OTP
      console.error('Error sending OTP:', error);

      // Handle errors
      const errorCode = error.code;
      console.log("errorCode", errorCode);

      const errorMessage = error.message;
      console.log("errorMessage", errorMessage);

      // Handle specific errors if needed
      // switch (errorCode) {
      //   case 'auth/error-code:-39':
      //     this._snackBar.open('Phone number is incorrect. Please enter a valid phone number', 'OKAY', { duration: 6000 })
      //     // Handle invalid phone number error
      //     break;
      //   case 'auth/missing-phone-number':
      //     this._snackBar.open('Phone number is incorrect. Please enter a valid phone number', 'OKAY', { duration: 6000 })
      //     // Handle missing phone number error
      //     break;
      //   // Add more cases for specific error handling as needed
      //   default:
      //     this._snackBar.open('Phone number is incorrect. Please enter a valid phone number', 'OKAY', { duration: 6000 })
      //   // Handle other errors
      // }

      switch (errorCode) {
        case 'auth/invalid-phone-number':
          this._snackBar.open('The phone number is invalid. Please enter a valid phone number.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/missing-phone-number':
          this._snackBar.open('Please enter a phone number.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/quota-exceeded':
          this._snackBar.open('The SMS quota for this project has been exceeded. Please try again later.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/captcha-check-failed':
          this._snackBar.open('Captcha verification failed. Please try again.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/operation-not-allowed':
          this._snackBar.open('Phone number sign-in is not enabled. Please contact support.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/too-many-requests':
          this._snackBar.open('We have blocked all requests from this device due to unusual activity. Please try again later.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/invalid-verification-code':
          this._snackBar.open('The verification code is invalid. Please check the code and try again.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/missing-verification-code':
          this._snackBar.open('Please enter the verification code sent to your phone.', 'OKAY', { duration: 6000 });
          break;
        default:
          this._snackBar.open('An error occurred while sending the OTP. Please try again.', 'OKAY', { duration: 6000 });
          break;
      }
    });
  }

  onOtpChange(otp) {
    this.otp = otp;
  }

  /* resend OTP */
  resendOtp() {
    const auth = getAuth();
    console.log("auth in resend otp", auth)
    console.log("this.phone ==>", this.phone)
    console.log("this.appVerifier ==>", this.appVerifier)
    this.afAuth.signInWithPhoneNumber(this.phone, this.appVerifier).then((res) => {
      this._snackBar.open("Otp sent again", "Okay", { duration: 2000 })
    })

    // this.attemptCounter++;
    // this.setCounter();
  }


  continue() {
    const auth = getAuth();
    const credential = PhoneAuthProvider.credential(this.verificationId, this.otp);
    // console.log('credential', credential);
    this.afAuth.signInWithCredential(credential).then(a => {
      this.afAuth.signOut();
      console.log("a", a);
      // after successful verification.
      this._matDialogRef.close({ verificationId: this.verificationId })
    }).catch((err) => {
      this._snackBar.open('Wrong OTP!', 'OKAY', { duration: 2000 });
    });;
  }


  ngOnDestroy(): void {
    this.windowRef.recaptchaVerifier = undefined;
  }

}
